import React, { Component } from "react";

import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { SuccessNotification } from "components/misc";
import { Container } from "design-react-kit";
import { adminService, networkErrorHelper } from "libs";

class AdminLessonTrainingRegistrationIDFormMini extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      selectedFile: null, // Stato per il file selezionato
    };
  }

  // Funzione per inviare il file all'API
  uploadFile = async () => {
    const { selectedFile } = this.state;
    const { accountExt, date, hourStart, classGroup, idClass } = this.props;

    if (!selectedFile) return;

    this.setState({ loading: true });

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("accountExt", accountExt);
    formData.append("date", date);
    formData.append("hourStart", hourStart);
    formData.append("classGroup", classGroup);
    formData.append("idClass", idClass);

    adminService
      .uploadLessonTrainingRegistrationIDByAccountExt(formData)
      .then(({ data }) => {
        SuccessNotification.render(
          "Importazione andata a buon fine. " + data.payload.cnt + " codici registrazione processati.",
          "Comunicazione"
        );

        this.setState({
          loading: false,
          selectedFile: null,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          selectedFile: null,
        });

        networkErrorHelper.notify(error);
        console.log(error);
      });
  };

  //--- ---

  render() {

    const { selectedFile, loading } = this.state;
    const { lessonTitle } = this.props;

    return (
      <>
        <Container>
          <h6 className="mb-2">Importazione Codici Registrazione: {lessonTitle}</h6>

          <div className="m-0">
            <div className="uploadForm uploadFormMini">
              {/* Input file nascosto */}
              <input
                className="uploadFormFile"
                type="file"
                accept=".csv, .xls, .xlsx"
                onChange={(e) => {
                  const file = e.target.files[0];
                  this.setState({ selectedFile: file });
                }}
                style={{ display: "none" }}
                ref={(input) => (this.fileInput = input)}
              />

              {/* Bottone per selezionare il file */}
              <div className="wrapperUploadBtn">
                <button
                  className="btn btn-primary bg-dark"
                  onClick={() => this.fileInput.click()}
                >
                  Seleziona un file da importare
                </button>

                {selectedFile && (
                  <p className="uploadFileName">{selectedFile.name}</p>
                )}
              </div>

              {/* Bottone per caricare il file */}
              <button
                className={`btn btn-primary ${loading === false ? 'bg-dark' : 'btn-danger' }`}
                style={{ marginTop: "10px" }}
                onClick={this.uploadFile}
                disabled={!selectedFile}
              >
                {(loading === false) ? 'IMPORTA FILE' : 'Attendere fine Importazione...'}
              </button>
            </div>
          </div>
        </Container>
      </>
    );
  }
}

export default withRouter(AdminLessonTrainingRegistrationIDFormMini);
